import { render, staticRenderFns } from "./BoxInCar.vue?vue&type=template&id=0177d3b9&"
import script from "./BoxInCar.vue?vue&type=script&lang=js&"
export * from "./BoxInCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports